import { createSlice } from "@reduxjs/toolkit";
import { options as initialOptions } from "../../../../config/options";
import {
  mapSkuToAssetId,
  mapHandleToAssetId,
  assetIdToProductType,
} from "../../services/skuMapper";
import { getHandle, getCollection } from "../../helpers/productHelpers";
import productValues from "../../assets/fabricProductValues";
const product = window.product || {};
let variantOptions = window.options || [];
// Filter out variant options when they're just a default variant title
variantOptions = variantOptions?.filter((option) => {
  return option.name !== "Title";
});
import _ from "lodash";

const collectionName = getCollection();
console.log("collectionName", collectionName);
const handle = getHandle();
const builderType = window.builderType || "threekit";

// in collages, we use both the assetId for the configurator, and the assetId for the individual product.
// in this case, we use childAssetId for the individual product
const threekitSlice = createSlice({
  name: "threekit",
  initialState: {
    options: initialOptions,
    cartItems: [],
    quaternion: {},
    assetId: mapSkuToAssetId(collectionName),
    childAssetId: mapHandleToAssetId(handle),
    loading: false,
    selectedProduct: product,
    showCustomize: false,
    builder: builderType,
    variantOptions: variantOptions,
    quantity:
      productValues[assetIdToProductType(mapSkuToAssetId(collectionName))]
        ?.min || 1,
    addToCartDisabled: false,
  },
  reducers: {
    updateOptions(state, action) {
      state.options = _.merge(state.options, action.payload);
    },
    updateCartItems(state, action) {
      state.cartItems = [...state.cartItems, action.payload];
    },
    setQuaternion(state, action) {
      state.quaternion = action.payload;
    },
    setQuantity(state, action) {
      state.quantity = action.payload;
    },
    setAssetId(state, action) {
      state.assetId = action.payload;
    },
    setChildAssetId(state, action) {
      state.childAssetId = action.payload;
    },
    setLoading(state, action) {
      state.loading = !!action.payload;
      if (state.loading) {
        state.addToCartDisabled = false;
      }
    },
    setSelectedProduct(state, action) {
      state.selectedProduct = action.payload;
    },
    updateThreekitState(state, action) {
      state = _.merge(state, action.payload);
    },
    setShowCustomize(state, action) {
      state.showCustomize = action.payload;
    },
    setAddToCartDisabled(state, action) {
      state.addToCartDisabled = !!action.payload;
    },
  },
});

export const {
  updateOptions,
  updateCartItems,
  setQuaternion,
  setQuantity,
  setAssetId,
  setChildAssetId,
  setLoading,
  setSelectedProduct,
  updateThreekitState,
  setShowCustomize,
  setAddToCartDisabled,
} = threekitSlice.actions;
export default threekitSlice.reducer;
